import React from 'react';
import { createRoot } from 'react-dom/client';

import WhatsOnSearch from '../react/WhatsOnSearch';
import { camelCaseObject } from '../../util/params';


export default class WhatsOnSearchRenderer {
  constructor(context) {
    this.context = context;
    this.root = this.context.querySelector('[data-whats-on-search-react-root]');
    this.reactRoot = createRoot(this.root);
    this.init();
  }

  googleHasLoaded() {
    this.context.classList.add('WhatsOnSearch-loaded');
  }

  init() {
    try {
      const model = this.root.dataset;
      const data = camelCaseObject(JSON.parse(model.whatsOnSearchData));
      const labels = camelCaseObject(JSON.parse(model.whatsOnSearchLabels));
      const api = model.whatsOnSearchApi;
      const parentItemId = model.whatsOnSearchParentItemId;

      if (this.reactRoot) {
        this.reactRoot.render(
          <WhatsOnSearch
            api={api}
            labels={labels}
            data={data}
            parentItemId={parentItemId}
            googleHasLoaded={() => this.googleHasLoaded()}
          />,
        );
      }
    } catch (e) {
      throw Error('Whats On Initial Data attributes are not populated correctly');
    }
  }
}
